import React, { useState, useEffect } from "react";
import Sidebar from "../Sidebar";
import Layout from "../Layout";
import "../..//index.css";
import EmployeeManagementTable from "./EmployeeManagementTable";
import CustomerManagementTable from "./CustomerManagementTable";
import AdminManagementTable from "./AdminManagementTable";
import Loader from "../../Loader";
import { useQuery } from "@apollo/client";
import { useAuthz } from "../../auth/useAuthz";
import { GET_EMPLOYEES, GET_ADMINS } from "../../graphql/userManagement";
import { useNavigate, useSearchParams } from "react-router-dom";

const UserManagement = () => {
  const { can } = useAuthz();
  const [searchParams, setSearchParams] = useSearchParams();

  const tab = searchParams.get("tab") || "employees";

  const isEmployeeManagement = tab === "employees";
  const isCustomerManagement = tab === "customers";
  const isAdminManagement = tab === "admins";

  const { data: employeeData, loading: empLoading } = useQuery(GET_EMPLOYEES, {
    fetchPolicy: "cache-and-network",
  });

  const { data: adminData, loading: adminLoading } = useQuery(GET_ADMINS, {
    fetchPolicy: "cache-and-network",
  });

  // const { data: customerData } = useQuery(GET_CUSTOMERS, {
  //   variables: { contactNumber: "" },
  //   fetchPolicy: "cache-first",
  // });

  const [addEmployee, setAddEmployee] = useState(false);
  const [editForm, setEditForm] = useState(false);
  const [editData, setEditData] = useState({});

  const employees = employeeData?.getEmployeelist?.employee || [];
  const admins = adminData?.getAdminList?.admins || [];
  // const customers = customerData?.getUserlist?.user || [];

  const loading = empLoading || adminLoading;

  if (loading) return <Loader />;

  return (
    <div className="min-h-screen flex">
      {/* Sidebar is fixed, reserve width space for it */}
      <Sidebar />

      {/* Main content area */}
      <Layout>
        <div className="flex flex-col space-y-6 w-full">
          {/* Header Section */}
          {!addEmployee && !editForm && (
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 pt-8 px-6">
              {/* Tabs */}
              <div className="flex flex-wrap text-[#FBB033] items-center font-be-jost-pro text-xl font-bold gap-3">
                <button
                  className={`${
                    isEmployeeManagement
                      ? "bg-white text-[#00395E]"
                      : "text-[#FBB034]"
                  } hover:bg-white hover:text-[#00395E] rounded-sm cursor-pointer text-base px-2 py-1 font-semibold`}
                  onClick={() => {
                    setSearchParams({ tab: "employees" });
                  }}
                >
                  Employee Management
                </button>

                <button
                  className={`${
                    isCustomerManagement
                      ? "bg-white text-[#00395E]"
                      : "text-[#FBB034]"
                  } hover:bg-white hover:text-[#00395E] rounded-sm cursor-pointer text-base px-2 py-1 font-semibold`}
                  onClick={() => {
                    setSearchParams({ tab: "customers" });
                  }}
                >
                  Customer Management
                </button>

                <button
                  className={`${
                    isAdminManagement
                      ? "bg-white text-[#00395E]"
                      : "text-[#FBB034]"
                  } hover:bg-white hover:text-[#00395E] rounded-sm cursor-pointer text-base px-2 py-1 font-semibold`}
                  onClick={() => {
                    setSearchParams({ tab: "admins" });
                  }}
                >
                  Admin Management
                </button>
              </div>

              {/* Add Button */}
              {can("adminManagement.create") && isAdminManagement && (
                <button
                  className="self-start sm:self-auto font-be-jost-pro font-medium text-sm border border-[#FBB033] text-[#FBB033] rounded-md px-5 py-2"
                  onClick={() => setAddEmployee(true)}
                >
                  Add Admin
                </button>
              )}
              {can("employeeManagement.create") && isEmployeeManagement && (
                <button
                  className="self-start sm:self-auto font-be-jost-pro font-medium text-sm border border-[#FBB033] text-[#FBB033] rounded-md px-5 py-2"
                  onClick={() => setAddEmployee(true)}
                >
                  Add Employee
                </button>
              )}
            </div>
          )}

          {/* Table Section */}
          <div className="w-full px-6 pb-6">
            {isEmployeeManagement ? (
              <EmployeeManagementTable
                data={employees}
                addEmployee={addEmployee}
                setAddEmployee={setAddEmployee}
                editForm={editForm}
                setEditForm={setEditForm}
                editData={editData}
                setEditData={setEditData}
                isFetched={!loading}
              />
            ) : isAdminManagement ? (
              <AdminManagementTable
                data={admins}
                addEmployee={addEmployee}
                setAddEmployee={setAddEmployee}
                editForm={editForm}
                setEditForm={setEditForm}
                editData={editData}
                setEditData={setEditData}
                isFetched={!loading}
              />
            ) : (
              <CustomerManagementTable data={[]} />
            )}
          </div>
        </div>
      </Layout>
    </div>
  );
};

export default UserManagement;
